import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import List from 'devextreme-react/list';
import type { UserPanelProps } from '../../types';
import { useAccount, useMsal } from '@azure/msal-react';
import { b2cPolicies } from '../../authConfig';
import { Tabs } from 'devextreme-react';
import { AssistitiApi, AssistitoStatusDTO } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import AssistitoEditAnagraficaPanel from './AssistitoEditAnagraficaPanel';
import AssistitoEditAnamnesiPanel from './AssistitoEditAnamnesiPanel';
import AssistitoEditMalattiePanel from './AssistitoEditMalattiePanel';
import AssistitoEditIntolleranzePanel from './AssistitoEditIntolleranzePanel';
import AssistitoEditTerapiePanel from './AssistitoEditTerapiePanel';
import AssistitoEditAllergiePanel from './AssistitoEditAllergiePanel';
import AssistitoEditTraumiPanel from './AssistitoEditTraumiPanel';
import AssistitoEditContattiPanel from './AssistitoEditContattiPanel';
import AssistitoEditPatologiaInfettivaPanel from './AssistitoEditPatologiaInfettivaPanel';
import TenantContext from '../../contexts/tenantContext';
import './AssistitoEditPanel.css';

type Props = {
  assistitoId: string;
  onchanged?: () => void;
  bloccaAnagrafica?: boolean;
  readOnly?: boolean;
}

export type AssistitoEditPanelHandle = {
}

const AssistitoEditPanel: React.ForwardRefRenderFunction<AssistitoEditPanelHandle, Props> = (props, ref) => {
  const tabs = ["Anagrafica", "Anamnesi generale", "Malattie", "Allergie", "Intolleranze", "Patologie infettive", "Terapie", "Traumi", "Contatti ICE"];
  const [currentTab, setCurrentTab] = useState<string>("Anagrafica");
  const { currentTenant } = useContext(TenantContext);
  const [status, setStatus] = useState<AssistitoStatusDTO>();

  useImperativeHandle(ref, () => ({

  }));

  useEffect(() => {
    refreshStatus();

  }, [props]);

  const refreshStatus = async function () {
    const api = new AssistitiApi(apiConfiguration);

    setStatus(await api.getAssistitoStatusById({ tenantId: currentTenant.Id, assistitoId: props.assistitoId }));
  };

  function isMarked(tab: string): boolean {
    if (tab === "Malattie") return status?.hasMalattie ?? false;
    else if (tab === "Allergie") return status?.hasAllergie ?? false;
    else if (tab === "Intolleranze") return status?.hasIntolleranze ?? false;
    else if (tab === "Patologie infettive") return status?.hasPatologieInfettive ?? false;
    else if (tab === "Terapie") return status?.hasTerapie ?? false;
    else if (tab === "Traumi") return status?.hasTraumi ?? false;
    else if (tab === "Contatti ICE") return status?.hasICE ?? false;
    else if (tab === "Anamnesi generale") return status?.hasAnamnesi ?? false;
    else return false;
  }

  function onchanged() {
    props.onchanged?.();

    refreshStatus();
  }

  return (
    <React.Fragment>
      <Tabs
        dataSource={tabs}
        selectedItem={currentTab}
        onSelectedItemChange={e => setCurrentTab(e)}
        stylingMode='primary'
        width={'100%'}
        showNavButtons={true}
        itemRender={e => (
          <div className={`dx-tab-text ${isMarked(e) ? 'marked' : ''}`}>
            <span className="dx-tab-text-span">
              {e}
              <span className="dx-tab-text-span-pseudo">
                {e}
              </span>
            </span>
          </div>
        )}
      />

      {currentTab === "Anagrafica" &&
        <AssistitoEditAnagraficaPanel assistitoId={props.assistitoId} onchanged={onchanged} bloccaAnagrafica={props.bloccaAnagrafica ?? false} readOnly={props.readOnly} />
      }

      {currentTab === "Anamnesi generale" &&
        <AssistitoEditAnamnesiPanel assistitoId={props.assistitoId} onchanged={onchanged} readOnly={props.readOnly} />
      }

      {currentTab === "Malattie" &&
        <AssistitoEditMalattiePanel assistitoId={props.assistitoId} onchanged={onchanged} readOnly={props.readOnly} />
      }

      {currentTab === "Allergie" &&
        <AssistitoEditAllergiePanel assistitoId={props.assistitoId} onchanged={onchanged} readOnly={props.readOnly} />
      }

      {currentTab === "Intolleranze" &&
        <AssistitoEditIntolleranzePanel assistitoId={props.assistitoId} onchanged={onchanged} readOnly={props.readOnly} />
      }

      {currentTab === "Patologie infettive" &&
        <AssistitoEditPatologiaInfettivaPanel assistitoId={props.assistitoId} onchanged={onchanged} readOnly={props.readOnly} />
      }

      {currentTab === "Terapie" &&
        <AssistitoEditTerapiePanel assistitoId={props.assistitoId} onchanged={onchanged} readOnly={props.readOnly} />
      }

      {currentTab === "Traumi" &&
        <AssistitoEditTraumiPanel assistitoId={props.assistitoId} onchanged={onchanged} readOnly={props.readOnly} />
      }

      {currentTab === "Contatti ICE" &&
        <AssistitoEditContattiPanel assistitoId={props.assistitoId} onchanged={onchanged} readOnly={props.readOnly} />
      }
    </React.Fragment>
  );
}

export default React.forwardRef(AssistitoEditPanel);